export default __webpack_public_path__ + "static/media/O-120.f1790922.png";